import React from 'react'
import { pdf } from '@react-pdf/renderer'
import { svgUrlToPngDataUrl } from './export'
import navLogo from 'img/logo_main-cropped.svg'

export function getPdfDownloadDate(): string {
    return new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
}

export async function getLogoPngDataUrl(): Promise<string> {
    // Logo viewBox is ~487×96 (≈5:1 ratio) — render at matching proportions
    return svgUrlToPngDataUrl(navLogo, 507, 100)
}

export async function buildImageMap(urls: string[]): Promise<Record<string, string>> {
    const unique = Array.from(new Set(urls.filter(Boolean)))
    const entries = await Promise.all(
        unique.map(async url => {
            try {
                const res = await fetch(url, { cache: 'reload' })
                const blob = await res.blob()
                const dataUrl = await new Promise<string>((resolve, reject) => {
                    const reader = new FileReader()
                    reader.onload = () => resolve(reader.result as string)
                    reader.onerror = reject
                    reader.readAsDataURL(blob)
                })
                return [url, dataUrl] as const
            } catch {
                return [url, url] as const
            }
        })
    )
    return Object.fromEntries(entries)
}

export async function downloadPdf(doc: React.ReactElement, fileName: string): Promise<void> {
    const blob = await pdf(doc).toBlob()
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = fileName
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
}
